import React from 'react';
import { CordexaLoader } from './CordexaLoader';

export type ChatInlineLoaderProps = {
  srLabel: string;
  className?: string;
  'data-testid'?: string;
};

export function ChatInlineLoader({
  srLabel,
  className,
  'data-testid': dataTestId = 'chat-inline-loader',
}: ChatInlineLoaderProps) {
  return (
    <div
      className={className}
      data-testid={dataTestId}
      role="status"
      aria-busy="true"
    >
      <CordexaLoader variant="dots" size="sm" srLabel={srLabel} />
    </div>
  );
}
